import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivarComponent } from './components/activar/activar.component';
import { ClientePedidosComponent } from './components/cliente-pedidos/cliente-pedidos.component';
import { ConsultaClienteComponent } from './components/consulta-cliente/consulta-cliente.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { PersonalComponent } from './components/personal/personal.component';
import { SrFormComponent } from './components/sr-form/sr-form.component';
import { SrHistoricoComponent } from './components/sr-historico/sr-historico.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MainFormComponent } from './main-form/main-form.component';
import { SrPendientesComponent } from './sr-pendientes/sr-pendientes.component';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'home', component: HomeComponent},
  {path: 'main', component: MainFormComponent},
  {path: 'login', component: LoginComponent},
  {path: 'sr', component: SrPendientesComponent},
  {path: 'srform', component: SrFormComponent},
  {path: 'cliente/:idsr/:idet', component: ConsultaClienteComponent},
  {path: 'cliente', component: ConsultaClienteComponent},
  {path: 'usuario', component: PersonalComponent},
  {path: 'historicosr', component: SrHistoricoComponent},
  {path: 'activar/:key', component: ActivarComponent},
  {path: 'miusuario', component: PerfilComponent},
  {path: 'mispedidos', component: ClientePedidosComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
